export const environment = {
  apiEndpoint: 'http://hmsapiv2.web2.anasource.com/api',
  mediaUrl: 'http://hmsapiv2.web2.anasource.com/PTDocs/',
  hubUrl: 'http://hmsapiv2.web2.anasource.com/hubs/hms'
};
